// extracted by mini-css-extract-plugin
module.exports = {"separator":"AccordionMenu_separator__I6E_Y"};